import React, { useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import "react-datepicker/dist/react-datepicker.css";
import "./AdmNewVisitor.css";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";


const AdmAttendanceEntry = () => {
  // const placementData = location.state?.placementData || {}; // Retrieve passed data
  const videoRef = useRef(null);
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const [image, setImage] = useState(null);
  const [isCameraOn, setIsCameraOn] = useState(false);

 const [visitorName, setVisitorName] = useState("");

  const [purposeOfVisit, setPurposeOfVisit] = useState("");
  const [whomToVisit, setWhomToVisit] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [visitorClass, setVisitorClass] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [section, setSection] = useState("");
  const [address, setAddress] = useState("");
  const [errors, setErrors] = useState({});
  const { classes } = useFetchClasses();
  const { sections } = useFetchSections(selectedClassId);


  function dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(",")[1]);
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  const fileInputRef = useRef(null);

  const validateFields = () => {
    const newErrors = {};

    if (!purposeOfVisit.trim())
      newErrors.purposeOfVisit = "Purpose is required";
    if (!whomToVisit.trim())
      newErrors.whomToVisit = "Whom to visit is required";

    const phoneRegex = /^[0-9]{10}$/;
    if (!phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!phoneRegex.test(phone)) {
      newErrors.phone = "Phone number must be 10 digits";
    }

    const emailValue = email.trim();
    if (emailValue) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailValue)) {
        newErrors.email = "Please enter a valid email address";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClear = () => {
    setVisitorName("");
    setPurposeOfVisit("");
    setWhomToVisit("");
    setPhone("");
    setEmail("");
    setVehicleNo("");
    setVisitorClass("");
    setSelectedClassId("");
    setSection("");
    setAddress("");
    setErrors({});
    setImage(null);
    setIsCameraOn(false);

    // Stop camera if active
    if (videoRef.current && videoRef.current.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }

    // Reset file input if required
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  

  // const handleSave = async () => {
  //    if (!validateFields()) return;
  //   const academic_year_id = localStorage.getItem("academicSessionId") || "";
  //   const org_id = localStorage.getItem("orgId") || "";
  //   const branch_id = localStorage.getItem("branchId") || "";
  //   const created_by = sessionStorage.getItem("userId") || "";

  //   const formData = new FormData();
  //   formData.append("academic_year_id", academic_year_id);
  //   formData.append("org_id", org_id);
  //   formData.append("branch_id", branch_id);
  //   formData.append("visitor_name", visitorName);
  //   formData.append("purpose_of_visit", purposeOfVisit);
  //   formData.append("whomToVisit", whomToVisit);
  //   formData.append("phone", phone);
  //   formData.append("email", email);
  //   formData.append("upload_file", image ? dataURItoBlob(image) : null); // convert base64 image
  //   formData.append("VehicleNo", vehicleNo);
  //   formData.append("visitDate", new Date().toISOString()); // Or let backend use default
  //   formData.append("department", department);
  //   formData.append("address", address);
  //   formData.append("created_by", created_by);

  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}VISITORS/create/`,
  //       {
  //         method: "POST",
  //         body: formData,
  //       }
  //     );

  //     const result = await response.json();
  //     console.log("Visitor API Response:", result);
  //     alert("Visitor entry saved successfully!");
  //   } catch (error) {
  //     console.error("Error submitting visitor data:", error);
  //     alert("Failed to save visitor entry.");
  //   }
  // };


  const handleSave = async () => {
    if (!validateFields()) return;

    const academic_year_id = localStorage.getItem("academicSessionId") || "";
    const org_id = localStorage.getItem("orgId") || "";
    const branch_id = localStorage.getItem("branchId") || "";
    const created_by = sessionStorage.getItem("userId") || "";

    const formData = new FormData();
    formData.append("academic_year_id", academic_year_id);
    formData.append("org_id", org_id);
    formData.append("branch_id", branch_id);
    formData.append("visitor_name", visitorName);
    formData.append("purpose_of_visit", purposeOfVisit);
    formData.append("whomToVisit", whomToVisit);
    formData.append("phone", phone);
    formData.append("email", email);

    // Convert base64 image to blob if exists
    if (image) {
      formData.append("upload_file", dataURItoBlob(image));
    }

    formData.append("VehicleNo", vehicleNo);

    // Pass only Date (YYYY-MM-DD) as Visit Date
    // Pass system local date + time in one field
    const now = new Date();
    const visitDateTime = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
      now.getHours()
    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
      now.getSeconds()
    ).padStart(2, "0")}`;

    formData.append("visitDate", visitDateTime);

    formData.append("visitor_class", visitorClass);
    formData.append("section", section);
    formData.append("address", address);
    formData.append("created_by", created_by);

    try {
      const response = await fetch(`${ApiUrl.apiurl}VISITORS/create/`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      console.log("Visitor API Response:", result);

      if (result.message === "success") {
        alert("Visitor entry saved successfully!");
        handleClear();
      } else {
        const backendError =
          result?.error?.email?.[0] ||
          result?.error?.non_field_errors?.[0] ||
          result?.error ||
          result?.message;
        alert(backendError || "Failed to save visitor entry.");
      }
    } catch (error) {
      console.error("Error submitting visitor data:", error);
      alert("Failed to save visitor entry.");
    }
  };
  

  // Start the camera
const startCamera = async () => {
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    alert(
      "Camera access requires a secure connection (HTTPS). Live camera won't work over plain HTTP on this server.",
    );
    return;
  }

  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    setIsCameraOn(true);
    if (videoRef.current) {
      videoRef.current.srcObject = stream;
    }
  } catch (error) {
    console.error("Camera access error:", error);
    if (error.name === "NotAllowedError") {
      alert(
        "Camera permission denied. Please allow camera access in your browser settings.",
      );
    } else if (error.name === "NotFoundError") {
      alert("No camera device found.");
    } else {
      alert("Unable to access camera: " + error.message);
    }
    setIsCameraOn(false);
  }
};

  // Capture the image
  const captureImage = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    if (canvas && video) {
      const context = canvas.getContext("2d");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      setImage(canvas.toDataURL("image/png"));
    }
  };

  // Upload the captured image
  const uploadImage = () => {
    if (image) {
      console.log("Uploading image:", image);
      alert("Image uploaded successfully!");
    }
  };

  const handleClose = () => {
    navigate("/admin/visitors-list");
  };

  const handleClassChange = (e) => {
    const classId = e.target.value;
    const selectedClass = classes.find(
      (classItem) => String(classItem.id) === String(classId)
    );

    setSelectedClassId(classId);
    setVisitorClass(selectedClass?.classname || "");
    setSection("");
  };

  const handleSectionChange = (e) => {
    const sectionId = e.target.value;
    const selectedSection = sections.find(
      (sectionItem) => String(sectionItem.section_id) === String(sectionId)
    );

    setSection(selectedSection?.sectionname || "");
  };

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="card p-2">
            <div className="card-body">
              <p
                className="text-center fw-bold mb-3"
                style={{ fontSize: "18px" }}
              >
                 ADD VISITORS
              </p>

              {/* Buttons Section */}

              {/* Buttons Section */}
              <div className="col-12 ">
                <button
                  type="button"
                  className="btn btn-primary me-2"
                  style={{
                    width: "150px",
                  }}
                  onClick={handleSave}
                >
                  Save
                </button>

                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  style={{
                    width: "150px",
                  }}
                  onClick={handleClear}
                >
                  Clear
                </button>
                <button
                  type="button"
                  className="btn btn-danger me-2"
                  style={{
                    width: "150px",
                  }}
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>

              {/* Form Section */}
              <div
                className="d-flex justify-content-center"
                style={{
                  border: "1px solid #ccc",
                  marginTop: "10px",
                  padding: "15px",
                  backgroundColor: "#EEF5FF",
                }}
              >
                <div
                  className="form-wrapper"
                  style={{ width: "100%", maxWidth: "600px" }}
                >
                  <form className="row">
                    {[
                      {
                        label: (
                          <>
                            Name <span style={{ color: "red" }}>*</span>
                          </>
                        ),

                        value: visitorName,
                        onChange: setVisitorName,
                      },
                      {
                        label: (
                          <>
                            Purpose Of Visit{" "}
                            <span style={{ color: "red" }}>*</span>
                          </>
                        ),
                        value: purposeOfVisit,
                        onChange: setPurposeOfVisit,
                        error: errors.purposeOfVisit,
                      },
                      {
                        label: (
                          <>
                            whom To  Visit{" "}
                            <span style={{ color: "red" }}>*</span>
                          </>
                        ),
                        value: whomToVisit,
                        onChange: setWhomToVisit,
                        error: errors.whomToVisit,
                      },
                      {
                        label: (
                          <>
                            Phone <span style={{ color: "red" }}>*</span>
                          </>
                        ),
                        value: phone,
                        onChange: setPhone,
                        error: errors.phone,
                        isPhone: true,
                      },

                      {
                        label: "Email",
                        value: email,
                        onChange: setEmail,
                        error: errors.email,
                      },
                      {
                        label: "Vehicle No",
                        value: vehicleNo,
                        onChange: setVehicleNo,
                      },
                    ].map((field, idx) => (
                      <div
                        className="col-12 d-flex align-items-center mb-3 justify-content-center"
                        key={idx}
                      >
                        <label
                          className="me-3 text-end"
                          style={{ minWidth: "160px", fontWeight: "500" }}
                        >
                          {field.label}
                        </label>
                        <div style={{ width: "60%" }}>
                          <input
                            type="text"
                            className="form-control detail"
                            value={field.value}
                            onChange={(e) =>
                              field.isPhone
                                ? /^\d{0,10}$/.test(e.target.value) &&
                                  field.onChange(e.target.value)
                                : field.onChange(e.target.value)
                            }
                          />
                          {field.error && (
                            <small className="text-danger">{field.error}</small>
                          )}
                        </div>
                      </div>
                    ))}

                    <div className="col-12 d-flex align-items-center mb-3 justify-content-center">
                      <label
                        className="me-3 text-end"
                        style={{ minWidth: "160px", fontWeight: "500" }}
                      >
                        Class
                      </label>
                      <div style={{ width: "60%" }}>
                        <select
                          className="form-select detail"
                          value={selectedClassId}
                          onChange={handleClassChange}
                        >
                          <option value="">Select Class</option>
                          {classes.map((classItem) => (
                            <option key={classItem.id} value={classItem.id}>
                              {classItem.classname}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-12 d-flex align-items-center mb-3 justify-content-center">
                      <label
                        className="me-3 text-end"
                        style={{ minWidth: "160px", fontWeight: "500" }}
                      >
                        Section
                      </label>
                      <div style={{ width: "60%" }}>
                        <select
                          className="form-select detail"
                          value={
                            sections.find(
                              (sectionItem) => sectionItem.sectionname === section
                            )?.section_id || ""
                          }
                          onChange={handleSectionChange}
                          disabled={!selectedClassId}
                        >
                          <option value="">Select Section</option>
                          {sections.map((sectionItem) => (
                            <option
                              key={sectionItem.section_id}
                              value={sectionItem.section_id}
                            >
                              {sectionItem.sectionname}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-12 d-flex align-items-start mb-3 justify-content-center">
                      <label
                        className="me-3 text-end"
                        style={{ minWidth: "160px", fontWeight: "500" }}
                      >
                        Address
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        className="form-control detail-textarea"
                        rows="3"
                        style={{ width: "60%" }}
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      ></textarea>
                    </div>
                  </form>

                  {/* Camera Section */}
                  <div className="camera-section mt-4 text-center">
                    <button
                      onClick={startCamera}
                      className="btn btn-info btn-sm"
                    >
                      Live Camera
                    </button>
                    {isCameraOn && (
                      <div className="mt-2">
                        <video
                          ref={videoRef}
                          autoPlay
                          className="video-feed"
                          style={{ maxWidth: "100%" }}
                        />
                      </div>
                    )}
                    <div className="mt-2">
                      <button
                        onClick={captureImage}
                        disabled={!isCameraOn}
                        className="btn btn-warning btn-sm me-2"
                      >
                        Capture
                      </button>
                      <button
                        onClick={uploadImage}
                        disabled={!image}
                        className="btn btn-success btn-sm"
                      >
                        Upload
                      </button>
                    </div>
                    <canvas ref={canvasRef} style={{ display: "none" }} />
                    {image && (
                      <div className="captured-image mt-3">
                        <h4>Captured Picture</h4>
                        <img
                          src={image}
                          alt="Captured"
                          style={{ maxWidth: "100%", height: "auto" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdmAttendanceEntry;
